module.exports = __webpack_public_path__ + "img/bg.5ed030d4.webp";